import { useHistory } from "react-router-dom";

import { AUTH_REDIRECT_URL_KEY, AUTH_SEARCH_PARAMS_KEY } from "../../src/routes/AuthGuard";

export const useLoginWithRedirect = () => {
  const history = useHistory();

  const loginWithRedirect = (redirectParams: {
    url: string;
    searchParams?: { [key: string]: string };
  }) => {
    if (redirectParams.url) {
      sessionStorage.setItem(AUTH_REDIRECT_URL_KEY, redirectParams.url);
    }
    if (redirectParams.searchParams) {
      sessionStorage.setItem(
        AUTH_SEARCH_PARAMS_KEY,
        new URLSearchParams(redirectParams.searchParams).toString()
      );
    }
    history.push("/");
  };
  return loginWithRedirect;
};
